import React from "react";
import "./Quote.css"; 

const Quote = ({ text}) => {
  return (
    <div className="hero-quote">
      <h1>{text}</h1>
    </div>
  );
};

export default Quote;
